import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocalstorageService } from '@services/localstorage.service';
import { NotifyService } from '@services/notify.service';
import { AuthService } from '../auth/auth.service';
import { SessionService } from '@services/session.service';

@Injectable()
export class AccessSessionInterceptor implements HttpInterceptor {
  private notifyOneMinute = false;
  private notifyFiveMinutes = false;

  constructor(
    private readonly localstorageService: LocalstorageService,
    private readonly notifyService: NotifyService,
    private readonly authService: AuthService,
    private readonly sessionService: SessionService,
    private readonly oauthService: OAuthService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.sessionService.isExpired) {
      return EMPTY;
    }

    const hasStoredToken = !!localStorage.getItem('access_token');
    if (this.authService.getSsoProvider && hasStoredToken && !this.oauthService.hasValidAccessToken()) {
      this.handleSessionExpiry();
      return EMPTY;
    }

    this.checkExpiryWarnings();

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleSessionExpiry();
          return EMPTY;
        }
        throw error;
      }),
    );
  }

  private handleSessionExpiry(): void {
    const isFirstCaller = this.sessionService.markExpired();
    if (!isFirstCaller) return;

    this.notifyService.clear();
    this.notifyService.showWarning(
      'Sessão expirada',
      'Sua sessão expirou. Você será redirecionado para o login em instantes.',
    );
    setTimeout(() => this.authService.logOut(), 5000);
  }

  private checkExpiryWarnings(): void {
    // Warning notifications only for RepomIdentity — Edenred Connect handles renewal automatically
    if (!this.authService.isTokenRepomIdentity) return;

    const expiresAt = this.localstorageService.getExpiresSession();
    const diff = expiresAt - Date.now();

    if (diff <= 60_000 && !this.notifyOneMinute) {
      this.notifyOneMinute = true;
      this.notifyService.showError(
        'Sessão',
        'Sua sessão irá expirar em 1 minuto. Realize o login novamente para continuar.',
      );
    } else if (diff <= 300_000 && diff > 60_000 && !this.notifyFiveMinutes) {
      this.notifyFiveMinutes = true;
      this.notifyService.showError('Sessão', 'Sua sessão irá expirar em 5 minutos. Fique atento!');
    }
  }
}
